module.exports = __webpack_public_path__ + "img/Weapon_80.e6fb5c13.png";